import { createServerFn } from "@tanstack/react-start";
import { obterLogs, registrarLog, limparBuffer } from "@/lib/log-servidor.server";

export type EntradaLogServidor = {
  seq: number;
  instante: string;
  nivel: "info" | "sucesso" | "erro";
  origem: string;
  mensagem: string;
  detalhes?: string;
};

/**
 * Entrega ao navegador os registros acumulados no buffer do servidor.
 * A função é pública: o buffer pode ser consultado antes mesmo do login,
 * para que o cliente acompanhe o diagnóstico da inicialização do sistema.
 * Na primeira chamada (depoisDe = 0) o buffer inteiro é descarregado; nas
 * seguintes só os registros novos são enviados.
 */
export const obterLogsServidor = createServerFn({ method: "GET" })
  .validator((input: { depoisDe?: number } | undefined) => ({
    depoisDe: Math.max(0, Math.trunc(Number(input?.depoisDe ?? 0)) || 0),
  }))
  .handler(async ({ data }): Promise<{ logs: EntradaLogServidor[]; ultimoSeq: number }> => {
    const resultado = obterLogs(data.depoisDe);
    if (data.depoisDe === 0) {
      // Após entregar o buffer ao primeiro cliente, esvaziá-lo para evitar
      // que os mesmos registros sejam enviados novamente a clientes futuros.
      try {
        limparBuffer();
      } catch {
        /* ignore */
      }
      registrarLog(
        "logs",
        `Cliente conectado: ${resultado.logs.length} registro(s) do buffer entregues ao navegador.`,
        { nivel: "sucesso" },
      );
    }
    return resultado;
  });
